"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarbonRemoval = exports.CarbonRemovalVariant = void 0;
const __1 = require("../");
const utils_1 = require("../utils");
/**
 * Currently only has a single variant as carbon removals are only available from the Impact Shop
 */
var CarbonRemovalVariant;
(function (CarbonRemovalVariant) {
    CarbonRemovalVariant["NORMAL"] = "normal";
})(CarbonRemovalVariant = exports.CarbonRemovalVariant || (exports.CarbonRemovalVariant = {}));
class CarbonRemoval {
    constructor(removal, project) {
        this._id = removal._id;
        this.createdAt = (0, utils_1.dateParser)(removal.createdAt);
        this.impactType = __1.ImpactType.CARBON_REMOVAL;
        this.invoiceId = removal.invoiceId;
        this.isMocked = removal.isMocked == true;
        this.isPending = removal.isPending == true;
        this.name = removal.name;
        this.numberOfTonnes = removal.numberOfTonnes;
        this.project = project;
        this.projectId = removal.projectId;
        this.variant = removal.variant;
    }
}
exports.CarbonRemoval = CarbonRemoval;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyYm9uLXJlbW92YWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY2FyYm9uLXJlbW92YWwvY2FyYm9uLXJlbW92YWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkJBQTRDO0FBQzVDLG9DQUFzQztBQUV0Qzs7R0FFRztBQUNILElBQVksb0JBRVg7QUFGRCxXQUFZLG9CQUFvQjtJQUM5Qix5Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBRlcsb0JBQW9CLEdBQXBCLDRCQUFvQixLQUFwQiw0QkFBb0IsUUFFL0I7QUFjRCxNQUFhLGFBQWE7SUFheEIsWUFBWSxPQUEwQixFQUFFLE9BQXdDO1FBQzlFLElBQUksQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQztRQUN2QixJQUFJLENBQUMsU0FBUyxHQUFHLElBQUEsa0JBQVUsRUFBQyxPQUFPLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDL0MsSUFBSSxDQUFDLFVBQVUsR0FBRyxjQUFVLENBQUMsY0FBYyxDQUFDO1FBQzVDLElBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLFNBQVMsQ0FBQztRQUNuQyxJQUFJLENBQUMsUUFBUSxHQUFHLE9BQU8sQ0FBQyxRQUFRLElBQUksSUFBSSxDQUFDO1FBQ3pDLElBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLFNBQVMsSUFBSSxJQUFJLENBQUM7UUFDM0MsSUFBSSxDQUFDLElBQUksR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDO1FBQ3pCLElBQUksQ0FBQyxjQUFjLEdBQUcsT0FBTyxDQUFDLGNBQWMsQ0FBQztRQUM3QyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixJQUFJLENBQUMsU0FBUyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUM7UUFDbkMsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUMsT0FBTyxDQUFDO0lBQ2pDLENBQUM7Q0FDRjtBQTFCRCxzQ0EwQkMifQ==